import React from "react";
import { ReactComponent as Cancel } from "../../../Assets/Image/svg/cancel.svg";
import { useForm } from "react-hook-form";
import Inputs from "../../share/input/Inputs";
import { BtnPrimary } from "../../share/buttons/Btn";
import useFetch from "../../../Hooks/useFetch";
import { useState } from "react";

function PriorityNewGroup({ close, name, list, all, getPriorityService }) {
    const [groupData, setGroupData] = useState();

    const createGroup = useFetch({
        method: "POST",
        url: `BootCampGroupService`,
        noHeader: false,
        trigger: false,
        caller: getPriorityService,
        data: groupData,
    });
    const {
        register,
        handleSubmit,
        control,
        formState: { errors },
    } = useForm();

    const onSubmit = (data) => {
        // {
        //   name.length === list.length ? all(true) : all(false);
        // }
        console.log("onSubmit ~ name:", name);
        let formData = new FormData();
        formData.append("bootcamp", 11);
        formData.append("group_name", data.name);
        // ? parametre idea_name bra chi hat???????
        formData.append("idea_name", "idea");
        formData.append("head", name.at(0));

        name.forEach((item) => {
            formData.append("users", item.toString());
        });

        setGroupData(formData);

        createGroup.reFetch();

        close(false);
    };
    return (
        <div className="AddnewsupportTicket relative">
            <button
                onClick={() => close(false)}
                className="AddnewsupportTicket-cancel absolute  "
            >
                <div>
                    <Cancel />
                </div>
            </button>
            <h3 className=" text-[#77498F] font-bold text-[2rem] leading-[3.2rem] text-center">
                ثبت گروه جدید
            </h3>
            <form onSubmit={handleSubmit(onSubmit)} className="mt-[5rem]">
                <Inputs
                    register={{
                        required: {
                            value: true,
                            message: "Enter Name",
                        },
                    }}
                    type="text"
                    name="name"
                    control={control}
                    placeholder="نام تیم *"
                    className="border-gray h-[6.4rem] w-full bg-white-dark placeholder-gray text-[1.8rem] pl-[1.4rem] pr-[1.4rem] rounded-[1.5rem] mb-[1.6rem]"
                />
                <div className=" text-left mt-[3rem]">
                    <BtnPrimary
                        className="py-[20px] px-[25px] flex mr-auto "
                        text="ثبت گروه"
                        type={"submit"}
                        htmlType="submit"
                    />
                </div>
            </form>
        </div>
    );
}

export default PriorityNewGroup;
